var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sa-col-lg7 sa-col-md6 sa-col-sm7 sa-col-xs7"},[_c('apexchart',{attrs:{"type":"bar","height":"180","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }